import { courseActions } from "./course-slice";
import { uiActions } from "../ui-slice";

export const GetCourses = (email, userId, showNotification) => {
  return async (dispatch) => {
    const GetCoursesInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aualaaba/course/getCourses`,
        {
          method: "POST",
          body: JSON.stringify({
            userName: email,
            // UserId: userId
            
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetCoursesInfo();
      if (response.result.errorCode === "OK") {
        
        dispatch(
          courseActions.setCourses({
            courses: response.data
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: "Información cargada correctamente",
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          courseActions.setCourses({
            statues: [],
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};

export const GetCourse = (id, userId, email) => {
  return async (dispatch) => {
    // dispatch(
    //   uiActions.showNotification({
    //     status: "pending",
    //     title: "Solicitando cargo",
    //     message: "Solicitando cargo al servidor.",
    //   })
    // );
    const getCourseInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/course/getCourseById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
            UserId: userId,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el curso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getCourseInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          courseActions.setCourse({
            course: response.data,
          })
        );
        // dispatch(
        //   uiActions.showNotification({
        //     status: "success",
        //     title: "Datos Cargados",
        //     message: response.result.message,
        //   })
        // );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          courseActions.setCourse({
            course: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el curso",
        })
      );
    }
  };
};

export const AddUserToWaitList = (courseId, userId, email) => {
  return async (dispatch) => {
    // dispatch(
    //   uiActions.showNotification({
    //     status: "pending",
    //     title: "Solicitando cargo",
    //     message: "Solicitando cargo al servidor.",
    //   })
    // );
    const getCourseInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/course/addToWaitList`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            UserId: userId,
            CourseId: courseId, 

          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el curso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getCourseInfo();
      if (response.result.errorCode === "OK") {
       
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      // if (response.result.errorCode === "Warning") {
      //   dispatch(
      //     uiActions.showNotification({
      //       status: "warning",
      //       title: "Advertencia",
      //       message: response.result.message,
      //     })
      //   );
      // }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el curso",
        })
      );
    }
  };
};